// src/app/pipes/number-k.pipe.ts

// <!-- Example usage -->
// <p>{{ 1500 | numberK }}</p>        <!-- 1.5k -->
// <p>{{ 1200000 | numberK }}</p>    <!-- 1.2M -->
// <p>{{ 9876543210 | numberK }}</p> <!-- 9.9B -->
// <p>{{ 123456 | numberK }}</p>     <!-- 123456 (since 123.456 has remainder) -->
// <p>{{ 1000 | numberK }}</p>       <!-- 1k (no remainder) -->

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberK'
})
export class NumberKPipe implements PipeTransform {
  transform(value: number, decimals: number = 0): string {
    if (!value) return '0';

    const units = ['', 'k', 'M', 'B', 'T'];
    const unitIndex = Math.floor(Math.log10(value) / 3);

    // Calculate the reduced number
    const divisor = Math.pow(1000, unitIndex);
    const reduced = value / divisor;

    // Check if there are remaining digits
    if (reduced % 1 !== 0) {
      return Math.floor(value).toString();  // Return full number if there are remaining digits
    }

    return `${reduced.toFixed(decimals)}${units[unitIndex]}`;
  }
}
